/* Progressive enhancement for rebuy/cart-items.html. No admin/configuration writes. */
(function () {
  'use strict';
  if (window.TeaCartInstalled || !window.TeaCartModel) return;
  window.TeaCartInstalled = true;
  const model = window.TeaCartModel;
  const packModel = window.TeaPackModel;
  // Tea To-Go rules (docs/CART_LOGIC.md) run only where the environment opts in.
  function packConfig() {
    const env = window.TeaAddonEnvironments?.[window.Shopify?.shop]?.packs;
    return env && packModel ? env : null;
  }
  let packProduct = null;
  async function packData(fresh = false) {
    const config = packConfig();
    if (!config) return null;
    if (fresh || !packProduct) packProduct = request('products/' + encodeURIComponent(config.packHandle) + '.js').catch(error => { packProduct = null; throw error; });
    const product = await packProduct;
    return { product, plans: packModel.packPlans(product) };
  }
  const products = new Map();
  const verifiedProducts = new Map(); // Reuse verified plans when Vue replaces a row.
  let displayedCart = null, displayedEntries = [], displayedPack = null;
  // The cart is always in exactly one state, and only the state decides what the shopper
  // can do (docs/CART_LOGIC.md):
  //   checking  the newest cart hasn't been checked yet (page load, after any change)
  //   ready     checked and follows the rules: the only state checkout works in
  //   fixing    breaks a rule; a correction runs, and a checkout press retries it
  //   updating  one of our writes is under way: nothing else may write
  //   stuck     a write's outcome is unknown: everything waits for a page refresh
  // `version` counts cart changes and writes; a check counts only if none happened while
  // it read the cart.
  const STATES = { checking: 'Checking your cart…', ready: '', fixing: 'Your cart needs a quick update before checkout.',
    updating: 'Updating your cart…', stuck: "We couldn't confirm your last cart update. Refresh the page to continue." };
  let state = { name: 'checking', message: STATES.checking }, version = 0;
  function enter(name, message = STATES[name]) {
    if (state.name === 'stuck') return; // Only a page refresh leaves it.
    state = { name, message };
    roots().forEach(root => {
      drawer(root).dataset.teaState = name;
      drawer(root).toggleAttribute('aria-busy', name === 'updating');
    });
  }
  const writing = () => state.name === 'updating' || state.name === 'stuck';
  // A notice describes the cart it was shown for; any later change to the cart clears it.
  let noticeFor = null;
  const cartSignature = cart => JSON.stringify(cart?.items.map(item => [item.key, item.quantity]));
  let timer, refreshing = null, refreshQueued = false;
  const rootURL = () => window.Shopify?.routes?.root || '/';
  const roots = () => Array.from(document.querySelectorAll('[data-tea-cart]'));
  const drawer = root => root.closest('.rebuy-cart__flyout') || root;
  function node(tag, className, text) {
    const value = document.createElement(tag);
    if (className) value.className = className;
    if (text !== undefined) value.textContent = text;
    return value;
  }
  function button(label, action, value, disabled = false) {
    const element = node('button', 'tea-cart__button', label);
    element.type = 'button';
    element.dataset.teaAction = action;
    if (value !== undefined) element.dataset.value = value;
    element.disabled = disabled;
    return element;
  }
  const request = (path, body) => window.TeaCartSession.request(path, body);
  async function product(item, fresh = false) {
    if (!item.handle || !Number.isSafeInteger(item.variant_id)) return null;
    const key = item.handle;
    if (fresh) products.delete(key);
    if (!products.has(key)) products.set(key, request('products/' + encodeURIComponent(key) + '.js').catch(error => { products.delete(key); throw error; }));
    const data = model.productData(await products.get(key), item.variant_id);
    verifiedProducts.set(key + ':' + item.variant_id, data);
    return data;
  }
  function status(message) {
    roots().forEach(root => {
      const element = root.querySelector('[data-tea-cart-status]');
      element.textContent = message;
      element.dataset.feedback = ['', 'Cart updated.', 'Updating your cart…'].includes(message) ? 'quiet' : 'error';
    });
  }
  function money(amount, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(amount / 100);
  }
  function renderLine(line, item, data, currency, offersAllowed) {
    const controls = line.querySelector('[data-tea-tier-controls]');
    const offer = line.querySelector('[data-tea-tier-offer]');
    if (!controls || !offer) return;
    const current = model.state(item, data);
    if (!line.classList.contains('tea-cart__tier-line')) line.classList.add('tea-cart__tier-line'); // Even a no-op add is a mutation.
    line.teaData = { item, data };
    let rewards = line.querySelector('[data-tea-line-rewards]');
    if (!rewards) {
      rewards = node('div');
      rewards.setAttribute('data-tea-line-rewards', '');
      line.prepend(rewards);
    }
    // With Tea To-Go rules on, one cart-level box bar replaces per-line panels.
    rewards.hidden = !current || Boolean(packConfig());
    if (current && !packConfig()) renderRewardPanel(rewards, current);
    // Rebuy can enrich/mutate the response with transient product/status fields.
    // Only visible inputs should cause the controls to be rebuilt.
    const signature = JSON.stringify([
      current, item.key, item.product_title, item.final_line_price, item.original_line_price,
      item.selling_plan_allocation?.compare_at_price, data.variant.requires_selling_plan,
      data.variant.price, data.plans.map(plan => [plan.id, plan.price, plan.recurring_deliveries, plan.options]),
      currency, offersAllowed
    ]);
    if (line.teaSignature === signature && controls.childElementCount) return;
    line.teaSignature = signature;
    controls.replaceChildren();
    offer.replaceChildren();
    controls.hidden = false;
    offer.hidden = true;
    if (!current) {
      controls.append(node('p', 'tea-cart__detail', 'This subscription needs review. Remove it and select a plan on the product page.'));
      return;
    }
    controls.append(node('p', 'tea-cart__detail', current.mode === 'subscription' ? 'Subscription · 30 sachets per box' : 'One-time purchase · ships once · 30 sachets per box'));
    if (current.mode === 'subscription') {
      const cadence = node('div', 'tea-cart__cadence');
      const select = node('select');
      select.setAttribute('aria-label', 'Delivery interval for ' + item.product_title);
      select.dataset.teaAction = 'months';
      for (let month = 1; month <= 3; month++) {
        const option = node('option', '', 'Every ' + month + (month === 1 ? ' month' : ' months'));
        option.value = month;
        option.disabled = !model.resolve(data, item.quantity, month);
        select.append(option);
      }
      select.value = current.months;
      cadence.append(select);
      controls.append(cadence);
    }
    const row = node('div', 'tea-cart__price-row');
    const quantity = node('div', 'tea-cart__quantity');
    const less = button('−', 'quantity', -1);
    less.setAttribute('aria-label', 'Decrease quantity of ' + item.product_title);
    const more = button('+', 'quantity', 1, current.mode === 'subscription' && !model.resolve(data, item.quantity + 1, current.months));
    more.setAttribute('aria-label', 'Increase quantity of ' + item.product_title);
    quantity.append(less, node('span', '', String(item.quantity)), more);
    const price = node('div', 'tea-cart__price');
    price.append(node('strong', '', money(item.final_line_price, currency)));
    const compare = current.mode === 'subscription' ? item.selling_plan_allocation?.compare_at_price * item.quantity : item.original_line_price;
    if (Number.isFinite(compare) && compare > item.final_line_price) price.append(node('s', '', money(compare, currency)));
    row.append(quantity, price);
    controls.append(row);
    // Next tier, then the free pack (its threshold has one owner: TeaPackModel.GIFT_BOXES).
    const cta = model.reward(current).cta || (packConfig() && item.quantity === packModel.GIFT_BOXES - 1
      ? 'Add a ' + packModel.GIFT_BOXES + 'th box — get free Tea To-Go with every delivery' : '');
    if (current.mode === 'subscription' && offersAllowed && cta && model.resolve(data, item.quantity + 1, current.months)) {
      const box = node('div', 'tea-cart__offer');
      box.append(node('span', '', cta));
      const add = button('Add a box', 'quantity', 1);
      add.setAttribute('aria-label', cta);
      box.append(add);
      offer.append(box);
    }
    if (current.mode === 'onetime') {
      const plan = model.resolve(data, item.quantity, Math.min(item.quantity, 3));
      if (plan && data.variant.price > 0) {
        const saving = Math.round(100 * (1 - plan.price / data.variant.price));
        const box = node('div', 'tea-cart__offer tea-cart__offer--subscription');
        box.append(node('span', '', 'Subscribe & save ' + saving + '% — cancel anytime.'), button('Subscribe now', 'subscribe'));
        offer.append(box);
      }
    }
    offer.hidden = !offer.childElementCount;
  }
  function renderRewards(root, cart, entries) {
    const placeholder = root.querySelector('[data-tea-cart-rewards]');
    const progressComponent = drawer(root).querySelector('[data-rebuy-component="progress-bar"]');
    // Each verified tea line owns its rewards. Hide only native milestones,
    // preserving Rebuy's separate gift section and all native gift handling.
    progressComponent?.querySelector('[data-tea-cart-rewards]')?.remove();
    const config = packConfig();
    // With Tea To-Go rules on, ours is the only bar in every cart (Rebuy's keeps
    // running hidden, so its gift still adds itself at 4 boxes).
    const active = Boolean(config) || cart.items.length === 0 || entries.some(entry => model.state(entry.item, entry.data));
    drawer(root).classList.toggle('tea-cart-rewards-active', active);
    if (config) {
      placeholder.hidden = false;
      renderBoxProgress(placeholder, packModel.state(cart, config));
      return;
    }
    placeholder.hidden = cart.items.length !== 0;
    if (!placeholder.hidden) renderRewardPanel(placeholder, null);
  }
  function renderBoxProgress(panel, state) {
    const reward = packModel.reward(state);
    const signature = JSON.stringify(reward);
    if (panel.teaSignature === signature) return;
    panel.teaSignature = signature;
    const labels = node('ol', 'tea-cart__milestones');
    reward.labels.forEach((text, index) => labels.append(node('li', reward.reached[index] ? 'is-reached' : '', text)));
    const progress = node('div', 'tea-cart__progress');
    progress.setAttribute('role', 'progressbar');
    progress.setAttribute('aria-label', 'Box rewards');
    progress.setAttribute('aria-valuemin', '0');
    progress.setAttribute('aria-valuemax', '100');
    progress.setAttribute('aria-valuenow', String(Math.round(reward.progress * 100)));
    progress.setAttribute('aria-valuetext', reward.message);
    const fill = node('span');
    fill.style.width = reward.progress * 100 + '%';
    progress.append(fill);
    panel.replaceChildren(labels, progress, node('p', 'tea-cart__reward-message', reward.message));
  }
  // The two ways to buy a pack, priced for this cart: every delivery (only with a tea
  // subscription; one subscription per cart; not where the store sells packs as a bundle,
  // `recurring: false`) and this order only. The add block shows
  // the price in its dropdown; a pack line already shows its price beside the quantity.
  function packChoices(s, data, currency) {
    const variant = data.product.variants?.[0];
    const choices = [];
    if (s.subscriptions.size === 1 && packConfig().recurring !== false) {
      const [[cadence, boxes]] = s.subscriptions;
      const plan = packModel.planFor(data.plans, cadence, boxes);
      const unit = variant?.selling_plan_allocations?.find(value => value.selling_plan_id === plan)?.price;
      if (plan && Number.isFinite(unit)) choices.push({ kind: 'recurring', name: 'Every delivery', price: money(unit, currency) });
    }
    if (Number.isFinite(variant?.price)) choices.push({ kind: 'once', name: 'This order only', price: money(variant.price, currency) });
    return choices;
  }
  const priced = choice => choice.name + ' · ' + choice.price;
  function choiceSelect(choices, value, label, text) {
    const select = node('select', 'tea-cart__choice');
    select.setAttribute('aria-label', label);
    choices.forEach(choice => { const option = node('option', '', text(choice)); option.value = choice.kind; select.append(option); });
    select.value = value;
    return select;
  }
  // Tea To-Go upsell (sidecart brief mockup: photo, name, price, ADD). Shown until the
  // cart has its pack row; more packs are added on that row.
  function renderPacks(root, cart, data, currency) {
    const config = packConfig();
    let slot = root.querySelector('[data-tea-packs]');
    if (!slot) {
      slot = node('div');
      slot.setAttribute('data-tea-packs', '');
      (root.querySelector('[data-smartcart-items]') || root.lastElementChild)?.after(slot);
    }
    const s = packModel.state(cart, config);
    const choices = packChoices(s, data, currency);
    // Packs only ship with tea (Natazia, Oct 7); one pack row per order.
    slot.hidden = !s.boxes || s.paid > 0 || !choices.length || Boolean(packModel.blocked(s, 'once'));
    if (slot.hidden) return;
    const signature = JSON.stringify([choices, data.product.featured_image]);
    if (slot.teaSignature === signature) return;
    slot.teaSignature = signature;
    const heading = node('div', 'tea-packs__heading');
    heading.append(node('strong', '', 'Add Tea To-Go'));
    const body = node('div', 'tea-packs__body');
    const src = data.product.featured_image;
    if (typeof src === 'string' && src) {
      const image = node('img', 'tea-packs__image');
      image.src = (src.startsWith('//') ? 'https:' : '') + src + (src.includes('?') ? '&' : '?') + 'width=240';
      image.alt = data.product.title || '5 Single-Serve Packets';
      image.width = 104; image.height = 104; image.loading = 'lazy';
      body.append(image);
    }
    const main = node('div', 'tea-packs__main');
    main.append(node('span', 'tea-packs__title', '5 Single-Serve Packets'), node('span', 'tea-packs__detail', 'Ships with your tea'));
    const row = node('div', 'tea-packs__add');
    // Default: every delivery when there is a subscription (Kirke, Oct 10).
    const select = choices.length > 1 ? choiceSelect(choices, choices[0].kind, 'How often: 5 Single-Serve Packets', priced) : node('span', 'tea-packs__detail', priced(choices[0]));
    if (choices.length > 1) select.setAttribute('data-tea-pack-kind', '');
    const add = button('Add', '', undefined);
    add.removeAttribute('data-tea-action');
    Object.assign(add.dataset, { teaPack: 'add', kind: choices.length > 1 ? '' : choices[0].kind });
    add.setAttribute('aria-label', 'Add 5 Single-Serve Packets');
    row.append(select, add);
    main.append(row);
    body.append(main);
    slot.replaceChildren(heading, body);
  }
  // A pack line: how it ships (dropdown), its own quantity and price, and the limit when
  // it is reached. Rebuy's own cadence selector is hidden: a subscribed pack follows its tea.
  function renderPackLine(line, item, s, data, currency) {
    const controls = line.querySelector('[data-tea-tier-controls]');
    const offer = line.querySelector('[data-tea-tier-offer]');
    const pack = s.packs.find(value => value.key === item.key);
    if (!controls || !pack) return;
    if (!line.classList.contains('tea-cart__pack')) line.classList.add('tea-cart__pack'); // Even a no-op add is a mutation.
    if (offer) offer.hidden = true;
    const more = pack.kind === 'gift' ? null : packModel.blocked(s, pack.kind);
    const choices = pack.kind === 'gift' ? [] : packChoices(s, data, currency);
    const signature = JSON.stringify([pack, more, choices, s.subscribed >= packModel.GIFT_BOXES, item.final_line_price, item.original_line_price, item.selling_plan_allocation?.compare_at_price, currency]);
    if (line.teaSignature === signature && controls.childElementCount) return;
    line.teaSignature = signature;
    controls.replaceChildren();
    controls.hidden = false;
    if (pack.kind === 'gift') controls.append(node('p', 'tea-cart__detail', 'Free with ' + packModel.GIFT_BOXES + '+ boxes · ' + (s.subscribed >= packModel.GIFT_BOXES ? 'every delivery' : 'this order')));
    else if (choices.length > 1) {
      const select = choiceSelect(choices, pack.kind, 'How often: ' + item.product_title, choice => choice.name);
      Object.assign(select.dataset, { teaPackChoice: '', key: item.key });
      const cadence = node('div', 'tea-cart__cadence'); // Same box as the tea's delivery dropdown.
      cadence.append(select);
      controls.append(cadence);
    } else controls.append(node('p', 'tea-cart__detail', 'This order only'));
    const row = node('div', 'tea-cart__price-row');
    if (pack.kind !== 'gift') {
      const quantity = node('div', 'tea-cart__quantity');
      const less = button('−', '', undefined);
      const plus = button('+', '', undefined, Boolean(more));
      [[less, -1], [plus, 1]].forEach(([control, delta]) => {
        control.removeAttribute('data-tea-action');
        Object.assign(control.dataset, { teaPack: 'step', key: item.key, delta });
      });
      less.setAttribute('aria-label', 'Decrease quantity of ' + item.product_title);
      plus.setAttribute('aria-label', more || 'Increase quantity of ' + item.product_title);
      quantity.append(less, node('span', '', String(item.quantity)), plus);
      row.append(quantity);
    }
    const price = node('div', 'tea-cart__price');
    price.append(node('strong', '', pack.kind === 'gift' && item.final_line_price === 0 ? 'Free' : money(item.final_line_price, currency)));
    const compare = pack.kind === 'recurring' ? item.selling_plan_allocation?.compare_at_price * item.quantity : item.original_line_price;
    if (Number.isFinite(compare) && compare > item.final_line_price) price.append(node('s', '', money(compare, currency)));
    row.append(price);
    controls.append(row);
    if (more) controls.append(node('p', 'tea-cart__detail tea-cart__limit', more)); // Natazia: say when they're at the max.
  }
  function renderRewardPanel(panel, current) {
    const reward = model.reward(current);
    const label = !current ? 'Box rewards' : current.mode === 'onetime'
      ? 'One-time box rewards' : 'Subscription rewards — every ' + current.months + (current.months === 1 ? ' month' : ' months');
    const signature = JSON.stringify([reward, label]);
    if (panel.teaSignature === signature) return;
    panel.teaSignature = signature;
    const labels = node('ol', 'tea-cart__milestones');
    reward.labels.forEach((text, index) => {
      const threshold = current?.mode === 'onetime' ? [0.25, 0.5, 1][index] : (index + 1) / 3;
      const li = node('li', reward.progress >= threshold ? 'is-reached' : '', text);
      labels.append(li);
    });
    const progress = node('div', 'tea-cart__progress');
    progress.setAttribute('role', 'progressbar');
    progress.setAttribute('aria-label', label);
    progress.setAttribute('aria-valuemin', '0');
    progress.setAttribute('aria-valuemax', '100');
    progress.setAttribute('aria-valuenow', String(Math.round(reward.progress * 100)));
    progress.setAttribute('aria-valuetext', reward.message);
    const fill = node('span');
    fill.style.width = reward.progress * 100 + '%';
    progress.append(fill);
    panel.replaceChildren(labels, progress, node('p', 'tea-cart__reward-message', reward.message));
  }
  function refresh(cart = null, owned = false) {
    document.querySelectorAll('.tea-cart').forEach(element => {
      if (!element.matches('[data-tea-cart]') && !element.querySelector('[data-tea-cart]')) {
        element.classList.remove('tea-cart', 'tea-cart-rewards-active', 'tea-cart--no-packets');
        delete element.dataset.teaState;
      }
    });
    if ((writing() && !owned) || !roots().length) return Promise.resolve('skipped');
    if (refreshing) return refreshing; // Coalesce Rebuy's burst of refresh events.
    refreshing = paintCart(cart, owned).finally(() => {
      refreshing = null;
      if (refreshQueued) { refreshQueued = false; schedule(); }
    });
    return refreshing;
  }
  // Vue replaces keyed lines (and can reset their classes) when plans change.
  // Reapply verified controls in the mutation microtask, before browser paint,
  // rather than exposing native controls during the debounced/network refresh.
  // The controls last drawn for each kind of row, to stand in while Vue replaces a row
  // (a tier change gives the tea line a new key) and the new cart is still loading.
  const lastControls = new Map();
  const rowKind = snapshot => snapshot.variant_id + ':' + (snapshot.selling_plan_allocation ? 'plan' : 'once');
  function remember(line, snapshot) {
    const controls = line.querySelector('[data-tea-tier-controls]');
    if (controls?.childElementCount) lastControls.set(rowKind(snapshot), controls.cloneNode(true));
  }
  function restoreVerifiedLines() {
    if (!displayedCart) return;
    const entries = displayedCart.items.map(item => ({ item, data: verifiedProducts.get(item.handle + ':' + item.variant_id) })).filter(entry => entry.data);
    const packs = displayedPack && packModel.state(displayedCart, packConfig());
    roots().forEach(root => {
      root.querySelectorAll('[data-tea-line]').forEach(line => {
        const snapshot = JSON.parse(line.dataset.teaLine);
        const item = displayedCart.items.find(value => value.key === snapshot.key && value.quantity === snapshot.quantity);
        const entry = item && entries.find(entry => entry.item === item);
        if (packs && item?.variant_id === packConfig().packVariantId) {
          line.teaChecked = true;
          renderPackLine(line, item, packs, displayedPack, displayedCart.currency);
        } else if (entry) {
          line.teaChecked = true;
          renderLine(line, entry.item, entry.data, displayedCart.currency, entries.length === 1);
        } else if (verifiedProducts.has(snapshot.handle + ':' + snapshot.variant_id) || snapshot.variant_id === packConfig()?.packVariantId) {
          // A tea or pack row this cart hasn't loaded yet: never show Rebuy's own controls
          // in between; keep the last controls (under the loading overlay) until it has.
          if (!line.classList.contains('tea-cart__pending')) line.classList.add('tea-cart__pending');
          const controls = line.querySelector('[data-tea-tier-controls]');
          const stand = lastControls.get(rowKind(snapshot));
          if (controls && stand && !controls.childElementCount) { controls.replaceChildren(...stand.cloneNode(true).childNodes); controls.hidden = false; }
          delete line.teaSignature;
        }
      });
    });
  }
  // Draws the cart, and (outside an action) checks it. Returns false when the cart couldn't
  // be read. An action's own drawing doesn't decide the state: the action ends with a
  // fresh check, since Rebuy usually changes the cart again as it ends.
  async function paintCart(snapshot, owned) {
    const seen = version;
    try {
      const cart = snapshot || await request('cart.js');
      const entries = (await Promise.all(cart.items.map(async item => {
        const data = await product(item);
        return data ? { item, data } : null;
      }))).filter(Boolean);
      const config = packConfig();
      const pack = config ? await packData() : null;
      if (!owned && (version !== seen || writing())) return 'superseded';
      // SmartCart.setCart returns before Rebuy finishes its asynchronous row
      // replacement. Keep the previous UI intact until DOM keys/quantities agree
      // with Shopify; otherwise old rows briefly lose enhancement and rewards
      // advance ahead of the quantity. Never match replacement rows by variant.
      if (snapshot && owned) await waitForCartRows(cart);
      if (noticeFor && !owned && cartSignature(cart) !== noticeFor) { noticeFor = null; status(''); }
      displayedCart = cart; displayedEntries = entries; displayedPack = pack;
      const packs = pack && packModel.state(cart, config);
      roots().forEach(root => {
        drawer(root).classList.add('tea-cart');
        drawer(root).dataset.teaState = state.name; // A re-rendered drawer keeps showing the state.
        drawer(root).classList.toggle('tea-cart--no-packets', !cart.items.some(model.isPacket));
        drawer(root).classList.toggle('tea-packs-active', Boolean(pack));
        root.querySelectorAll('[data-tea-line]').forEach(line => {
          const snapshot = JSON.parse(line.dataset.teaLine);
          line.teaChecked = true;
          const item = cart.items.find(value => value.key === snapshot.key);
          const entry = entries.find(value => value.item.key === snapshot.key);
          // Every pack is its own visible line: subscribed, this order only, or free.
          if (line.classList.contains('tea-cart__pending')) line.classList.remove('tea-cart__pending');
          if (packs && item?.variant_id === config.packVariantId) { renderPackLine(line, item, packs, pack, cart.currency); remember(line, snapshot); }
          else if (entry) { renderLine(line, entry.item, entry.data, cart.currency, entries.length === 1); remember(line, snapshot); }
          else {
            line.classList.remove('tea-cart__tier-line', 'tea-cart__pack');
            delete line.teaData;
            delete line.teaSignature;
            line.querySelectorAll('[data-tea-tier-controls], [data-tea-tier-offer], [data-tea-line-rewards]').forEach(slot => { slot.hidden = true; });
          }
        });
        renderRewards(root, cart, entries);
        if (pack) renderPacks(root, cart, pack, cart.currency);
      });
      // The same planners that make the corrections decide whether checkout can go ahead.
      let pending = false, verdict = '';
      try { pending = entries.some(entry => model.nextChange(cart, entry.data)) || Boolean(pack && packModel.nextChange(cart, config, pack.plans)); }
      catch (error) { verdict = error.message; }
      if (pending) verdict = STATES.fixing;
      if (!owned) settle({ verdict, pending });
      return true;
    } catch (_) {
      if (!owned && (version !== seen || writing())) return 'superseded';
      if (!owned) enter('checking', 'Cart details could not be refreshed. Please refresh the page.');
      status('Cart details could not be refreshed. Please refresh the page before changing your subscription.');
      return false;
    }
  }
  // Applies a check of the newest cart (a check that read an older cart was discarded);
  // a broken rule starts its correction, whoever changed the cart.
  function settle(check) {
    if (!check.verdict) return enter('ready');
    enter('fixing', check.verdict);
    if (check.pending && displayedCart) autoReconcile(displayedCart, displayedEntries);
  }
  function waitForCartRows(cart) {
    const matches = () => roots().every(root => {
      const rows = Array.from(root.querySelectorAll('[data-tea-line]'));
      return rows.every(line => {
        const row = JSON.parse(line.dataset.teaLine);
        return cart.items.some(item => item.key === row.key && item.quantity === row.quantity);
      }) && (cart.items.length === 0 || rows.length > 0);
    });
    if (matches()) return Promise.resolve();
    return new Promise((resolve, reject) => {
      const observer = new MutationObserver(() => { if (matches()) finish(); });
      const timeout = setTimeout(() => finish(new Error('Cart rows did not synchronize')), 5000); // Don't leave checkout locked indefinitely.
      function finish(error) { clearTimeout(timeout); observer.disconnect(); error ? reject(error) : resolve(); }
      observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-tea-line'] });
    });
  }
  // Rebuy's own line controls (trash, quantity) are run here, as the same Rebuy methods
  // those buttons call, inside the one cart lock the buy box and our controls share. The
  // lock is held until Rebuy's own callback for that operation; nothing else can write
  // meanwhile, and no other event or request can end it. If the callback never comes the
  // lock stays held (checkout too) and the shopper is told to refresh: an unconfirmed
  // write is never treated as done, and never sent again.
  function nativeOperation(element) {
    const remove = element.closest('.rebuy-cart__flyout-item-remove');
    if (remove) return 'removeItem';
    const step = element.closest('.rebuy-cart__flyout-item-quantity-widget-button');
    if (!step) return null;
    const buttons = Array.from(step.parentElement.querySelectorAll('.rebuy-cart__flyout-item-quantity-widget-button'));
    return buttons.indexOf(step) === 0 ? 'decreaseItem' : 'increaseItem';
  }
  function nativeAct(line, method) {
    const key = JSON.parse(line.dataset.teaLine).key;
    return exclusive(async () => {
      const item = window.Rebuy?.SmartCart?.items?.().find(value => value.key === key);
      if (!item || typeof window.Rebuy.SmartCart[method] !== 'function') throw new Error('Your cart changed. Please review it and try again.');
      await new Promise(resolve => {
        const slow = setTimeout(() => { window.TeaCartSession.hold(); enter('stuck'); status(STATES.stuck); }, 15000);
        window.Rebuy.SmartCart[method](item, () => { clearTimeout(slow); resolve(); });
      });
      return applyRules(await request('cart.js'));
    });
  }
  // Any cart change: checkout waits for this cart's own check.
  function cartChanged() {
    version++;
    if (state.name === 'ready') enter('checking');
    schedule();
  }
  function schedule() {
    if (writing()) { refreshQueued = true; return; } // Retain gift changes that finish during an action.
    if (refreshing) { refreshQueued = true; return; }
    clearTimeout(timer);
    timer = setTimeout(() => refresh(), 80);
  }
  function positionLoader(root) {
    const host = drawer(root);
    const area = root.closest('[data-rebuy-cart-scroll-area]') || root;
    // Anchor to the visible items region, not rows whose height changes by tier.
    // Observe only while updating; scrolling the items won't move this overlay.
    const place = () => {
      const bounds = area.getBoundingClientRect(), parent = host.getBoundingClientRect();
      Object.entries({ x: bounds.left - parent.left + host.scrollLeft, y: bounds.top - parent.top + host.scrollTop, width: bounds.width, height: bounds.height })
        .forEach(([key, value]) => host.style.setProperty('--tea-loader-' + key, value + 'px'));
    };
    place();
    const observer = new ResizeObserver(place);
    observer.observe(area);
    return () => observer.disconnect();
  }
  // Each Shopify response is authoritative; add.js returns only the added items.
  async function send(change) {
    const response = await request(change.endpoint, change.body);
    return change.endpoint === 'cart/add.js' ? request('cart.js') : response;
  }
  // Notices for corrections, from the cart before the change.
  const packNotes = {
    no_box: () => 'Tea To-Go ships with your tea, so packs without a box were removed.',
    capacity: s => s.capacity === 1 ? '1 box fits 1 Tea To-Go pack, so the extra was removed.' : 'Max 2 Tea To-Go packs per order, so the extra was removed.',
    gift_slot: (s, next) => s.packs.find(pack => pack.key === next.body.id)?.kind === 'recurring'
      ? 'Your Tea To-Go subscription is now 1 pack per delivery. With ' + packModel.GIFT_BOXES + '+ boxes your other pack is free.'
      : 'With ' + packModel.GIFT_BOXES + '+ boxes 1 Tea To-Go pack is free, so it replaces a paid one.',
    subscription_capacity: () => '1 subscribed box fits 1 Tea To-Go pack per delivery, so the extra was removed.',
    gift_conflict: s => s.coded ? "Your discount code can't be combined with the free Tea To-Go pack, so the pack was removed."
      : "The free Tea To-Go pack couldn't be applied, so it was removed.",
    parent_onetime: () => 'Tea To-Go switched to this order only, matching your tea.',
    one_choice_recurring: () => 'Tea To-Go is one choice per order, so all your packs now come every delivery.',
    one_choice_once: () => 'Tea To-Go is one choice per order, so all your packs are now for this order only.'
  };
  function oneSubscriptionNote(cart, data) {
    const months = [...model.cadences(cart, data)][0];
    return months ? 'One subscription per order, so all your boxes now ship every ' + (months === 1 ? 'month.' : months + ' months.') : '';
  }
  // Apply Tea To-Go rules one request at a time (docs/CART_LOGIC.md).
  async function reconcilePacks(cart) {
    const config = packConfig();
    if (!config) return { cart, message: '' };
    const data = await packData(true);
    const notes = [];
    for (let pass = 0; pass < 8; pass++) {
      const next = packModel.nextChange(cart, config, data.plans);
      if (!next) return { cart, message: notes.join(' ') };
      const note = packNotes[next.reason]?.(packModel.state(cart, config), next);
      if (note && !notes.includes(note)) notes.push(note);
      try { cart = await send(next); } catch (error) {
        if (error.unconfirmed) throw error; // Unknown outcome: the cart is held, never guessed at.
        // Someone else got there first (Rebuy removes its own gift below 4 boxes at the same
        // moment): a correction aimed at a line that is gone did nothing. Recompute from the
        // cart as it is now; never resend. Any other failure stands.
        const fresh = await request('cart.js');
        if (next.targets?.some(key => !fresh.items.some(item => item.key === key))) { cart = fresh; continue; }
        throw error;
      }
    }
    throw new Error('Your cart changed during the update. Please review it before trying again.');
  }
  // Every write runs here, one at a time, under the lock the buy box shares.
  async function exclusive(work, { onError, afterwards } = {}) {
    if (!window.TeaCartSession?.acquire()) return; // The one lock: held while writing, and for good once stuck.
    version++; // Checks that started before this write no longer count.
    clearTimeout(timer);
    refreshQueued = false;
    enter('updating');
    const loaders = roots().map(positionLoader);
    status(STATES.updating);
    let message = '', updatedCart = null;
    try {
      if (typeof window.Rebuy?.SmartCart?.setCart !== 'function') throw new Error('The cart is still loading. Please try again.');
      message = (await work()) || 'Cart updated.';
      updatedCart = await window.TeaCartSession.syncRebuy();
      displayedCart = updatedCart; // Authoritative response, never optimistic pricing.
    } catch (error) {
      // A write with no clear answer may still land later, after any read we make: the
      // cart waits for a refresh, the same as a Rebuy operation whose callback never comes.
      // Never resent. (TeaCartSession.request decides what is unconfirmed.)
      if (error.unconfirmed) { window.TeaCartSession.hold(); enter('stuck'); }
      message = error.unconfirmed ? STATES.stuck : error.message;
      try { updatedCart = await window.TeaCartSession.syncRebuy(); displayedCart = updatedCart; } catch (_) { /* Leave a clear status, not a fabricated cart. */ }
      onError?.();
    } finally {
      // An older read may still be finishing; it cannot render over this action.
      if (refreshing) await refreshing;
      const drawn = await refresh(updatedCart, true); // Keep spinner/guards until the DOM catches up.
      loaders.forEach(stop => stop());
      if (state.name === 'stuck') { status(STATES.stuck); return; } // The lock stays held.
      window.TeaCartSession.release();
      enter('checking'); // Every action ends with a fresh check of the cart.
      refreshQueued = false;
      schedule();
      status(drawn === false ? message + ' Refresh the page to reload cart details.' : message);
      noticeFor = cartSignature(displayedCart);
      afterwards?.();
    }
  }
  function act(line, action, value) {
    if (!line.teaData) return;
    const original = line.teaData.item;
    const focused = document.activeElement?.dataset.teaAction;
    const focusedValue = document.activeElement?.dataset.value;
    return exclusive(async () => {
      const data = await product(original, true);
      if (!data) throw new Error('This product’s plans could not be verified.');
      // Re-find the exact key immediately before the request (addressed by key). Never use variant alone.
      const cart = await request('cart.js');
      const latest = cart.items.find(item => item.key === original.key);
      if (!latest || latest.quantity !== original.quantity) throw new Error('Your cart changed. Please review it and try again.');
      const payload = model.change(cart, original.key, data, action, value);
      // A chosen interval wins; a line switched to subscribe joins the existing one.
      const existing = model.cadences(cart, data);
      const prefer = action === 'months' ? Number(value) : existing.size === 1 ? [...existing][0] : undefined;
      let updated = await request('cart/change.js', payload);
      const merging = model.cadences(updated, data).size > 1;
      updated = await model.normalize(updated, data, request, { prefer });
      const { cart: final, message } = await reconcilePacks(updated);
      return [merging ? oneSubscriptionNote(final, data) : '', message].filter(Boolean).join(' ');
    }, {
      // Restore a changed dropdown on rejection; successful, unchanged controls stay intact.
      onError: () => { delete line.teaSignature; },
      // Vue can replace the line when its selling-plan key changes. Restore keyboard focus.
      afterwards: () => {
        if (!focused) return;
        for (const root of roots()) {
          const candidates = Array.from(root.querySelectorAll('[data-tea-line]')).filter(el => el.teaData?.item.variant_id === original.variant_id);
          if (candidates.length === 1) {
            const target = Array.from(candidates[0].querySelectorAll('[data-tea-action]')).find(el => el.dataset.teaAction === focused && el.dataset.value === focusedValue && !el.disabled);
            target?.focus({ preventScroll: true });
          }
        }
      }
    });
  }
  // Pack actions: the upsell adds ({ kind }), a pack row's dropdown chooses ({ key, kind }),
  // its stepper steps its own exact line ({ key, delta }).
  function packAct(action, { kind, key, delta } = {}) {
    const config = packConfig();
    if (!config) return;
    return exclusive(async () => {
      const data = await packData(true);
      let cart = await request('cart.js');
      const s = packModel.state(cart, config);
      const changes = action === 'add' ? packModel.add(cart, config, data.plans, kind)
        : action === 'choose' ? packModel.choose(cart, config, data.plans, key, kind)
        : packModel.step(cart, config, key, Number(delta));
      const before = s.packs.find(pack => pack.key === key)?.quantity;
      const fewer = action === 'choose' && changes[0] && changes[0].body.quantity < before;
      for (const change of changes) cart = await send(change);
      const notes = [fewer ? '1 subscribed box fits 1 Tea To-Go pack per delivery, so the other was removed.' : '', (await reconcilePacks(cart)).message];
      return notes.filter(Boolean).join(' ');
    }, {
      // A rejected change: redraw the pack rows from the cart, not the shopper's unsaved pick.
      onError: () => roots().forEach(root => root.querySelectorAll('.tea-cart__pack, [data-tea-packs]').forEach(element => { delete element.teaSignature; })),
      // The row is redrawn (and Vue may replace it when its plan changes): keep keyboard
      // focus on the pack row's dropdown when the change started there.
      afterwards: () => {
        if (action !== 'choose') return;
        const selects = roots().flatMap(root => Array.from(root.querySelectorAll('[data-tea-pack-choice]')));
        // The same line when it survived (a rejected switch); else the one row it became.
        const target = selects.find(select => select.dataset.key === key) || (selects.length === 1 ? selects[0] : null);
        target?.focus({ preventScroll: true });
      }
    });
  }
  // Rules for changes made elsewhere (buy box, Rebuy). Once per distinct cart state,
  // so a failing rule can never loop.
  let autoSignature = '';
  function autoReconcile(cart, entries) {
    const signature = JSON.stringify([cart.items.map(item => [item.key, item.quantity]), cart.attributes || {}]);
    if (signature === autoSignature) return;
    autoSignature = signature;
    const variants = [...new Map(entries.map(entry => [entry.item.variant_id, entry.data])).values()];
    setTimeout(() => exclusive(async () => applyRules(await request('cart.js'), variants)), 0);
  }
  // Every rule, from a fresh cart: one subscription per cart, then Tea To-Go.
  async function applyRules(latest, variants = [...new Map(displayedEntries.map(entry => [entry.item.variant_id, entry.data])).values()]) {
    const notes = [];
    for (const data of variants) {
      const merging = model.cadences(latest, data).size > 1;
      latest = await model.normalize(latest, data, request);
      if (merging) notes.push(oneSubscriptionNote(latest, data));
    }
    const { message } = packConfig() ? await reconcilePacks(latest) : { message: '' };
    return [...notes, message].filter(Boolean).join(' ');
  }
  const CHECKOUT = '.rebuy-cart__checkout-button, .preferred-checkout-wrapper, [name="checkout"], a[href*="/checkout"]';
  // Our drawer from the template marker, before enhancement adds .tea-cart.
  const guarded = target => Boolean(target.closest('.tea-cart') || target.closest('.rebuy-cart__flyout')?.querySelector('[data-tea-cart]'));
  function handler(event) {
    const pack = event.target.closest('[data-tea-pack]');
    if (pack && event.target.closest('[data-tea-cart]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (event.type === 'click' && !pack.disabled && !writing() && !window.TeaCartSession?.busy) {
        // The add button takes the choice from its row's dropdown.
        const kind = pack.dataset.kind || pack.closest('.tea-packs__add')?.querySelector('[data-tea-pack-kind]')?.value;
        packAct(pack.dataset.teaPack, { kind, key: pack.dataset.key, delta: pack.dataset.delta });
      }
      return;
    }
    const choice = event.target.closest('[data-tea-pack-choice]');
    if (choice && event.type === 'change') {
      event.stopImmediatePropagation();
      if (writing() || window.TeaCartSession?.busy) { delete choice.closest('[data-tea-line]').teaSignature; schedule(); return; } // Put the dropdown back.
      packAct('choose', { key: choice.dataset.key, kind: choice.value });
      return;
    }
    // Checkout works only when the cart is ready (greyed out otherwise). A press meanwhile
    // says why; the shopper presses again. A press while a rule is broken retries the fix.
    const checkout = event.type === 'click' && guarded(event.target) && event.target.closest(CHECKOUT);
    if (checkout && (state.name !== 'ready' || window.TeaCartSession?.busy)) {
      event.preventDefault(); event.stopImmediatePropagation();
      const held = window.TeaCartSession?.unconfirmed ? STATES.stuck : null; // e.g. the buy box's unconfirmed add
      status(held || (state.name === 'ready' ? STATES.updating : state.message));
      if (state.name === 'fixing' && displayedCart) { autoSignature = ''; autoReconcile(displayedCart, displayedEntries); }
      return;
    }
    const target = event.target.closest('[data-tea-action]');
    const root = event.target.closest('[data-tea-cart]');
    if ((writing() || window.TeaCartSession?.busy) && event.target.closest('.tea-cart')) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    // Do not let Rebuy's generic subscription/quantity handler race plan discovery.
    const pendingLine = root && event.target.closest('[data-tea-line]');
    if (pendingLine && !pendingLine.teaChecked && !target) {
      const snapshot = JSON.parse(pendingLine.dataset.teaLine);
      const subscriptionControl = event.target.closest('.rebuy-cart__flyout-item-subscription');
      const tierQuantity = model.terms(snapshot.selling_plan_allocation?.selling_plan) && event.target.closest('.rebuy-cart__flyout-item-quantity');
      if (subscriptionControl || tierQuantity) {
        event.preventDefault(); event.stopImmediatePropagation();
        status('Subscription options are still loading. Please wait or refresh the page.');
        return;
      }
    }
    // Rebuy's trash and quantity buttons on a line: run under the cart lock (nativeAct).
    const native = event.type === 'click' && root && !target && event.target.closest('[data-tea-line]') && nativeOperation(event.target);
    if (native) {
      event.preventDefault(); event.stopImmediatePropagation();
      nativeAct(event.target.closest('[data-tea-line]'), native);
      return;
    }
    if (!root || !target || (event.type === 'click' && target.tagName === 'SELECT') || (event.type === 'change' && target.tagName !== 'SELECT')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!target.disabled) act(target.closest('[data-tea-line]'), target.dataset.teaAction, target.tagName === 'SELECT' ? target.value : target.dataset.value);
  }
  document.addEventListener('click', handler, true);
  document.addEventListener('change', handler, true);
  document.addEventListener('submit', event => {
    if ((state.name !== 'ready' || window.TeaCartSession?.busy) && guarded(event.target)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  ['rebuy:cart.change', 'rebuy:cart.enriched', 'rebuy:smartcart.ready', 'rebuy:smartcart.show'].forEach(name => document.addEventListener(name, cartChanged));
  new MutationObserver(records => {
    if (records.some(record => record.type === 'childList' || record.attributeName === 'data-tea-line' || (record.target.matches?.('[data-tea-line]') && !record.target.matches('.tea-cart__tier-line, .tea-cart__pack, .tea-cart__pending')))) restoreVerifiedLines();
    if (records.some(record => record.attributeName === 'data-tea-line' || Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(value => value.nodeType === 1 && (value.matches('[data-tea-cart], [data-tea-line]') || value.querySelector('[data-tea-cart], [data-tea-line]'))))) cartChanged();
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-tea-line', 'class'] });
  schedule();
})();
